import { jsonResponseExtractor, requestCommon } from 'live/lib/utils'
import { SourceUnitList } from './ModelsConfigTypes'
export function convertModelsUnits(unitConversionSourceItemList: SourceUnitList): Promise<SourceUnitList> {
    return fetch('/services/plugin-liverig/units/convert-all', {
        ...requestCommon,
        method: 'POST',
        body: JSON.stringify(unitConversionSourceItemList)
    }).then(jsonResponseExtractor)
}

export default {
    convertModelsUnits
}
